<template>
  <div id="layout-default" class="container-fluid p-0">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark flex-nowrap">
      <router-link
        class="navbar-brand group-logo p-3 border-default-dark border-right"
        :to="{ name: 'landing' }"
        v-if="user && user.username == 'infrasel@semesta.com.my'"
      >
        <img
          src="@/assets/images/infrasel-logo-white.png"
          class=""
          alt="InfraSEL"
        />
        <p class="mb-0 mt-n1 ml-2 text-muted">Smart Mining Monitoring</p>
      </router-link>
      <router-link
        class="navbar-brand group-logo p-3 border-default-dark border-right"
        :to="{ name: 'landing' }"
        v-else-if="user && user.username.includes('@jupem.gov.my')"
      >
        <img src="@/assets/images/selgem-logo.png" class="" alt="SELGEM" />
        <p class="mb-0 mt-0 ml-2 text-muted">Smart Mining Monitoring</p>
      </router-link>
      <router-link
        class="navbar-brand group-logo bg-semitrans-light justify-content-center align-items-center p-3 shadow-sm"
        :to="{ name: 'landing' }"
        v-else-if="user && user.company == 'KLM'"
      >
        <img src="@/assets/images/logo-klm.png" class="" alt="KLM" />
        <p class="mb-0 text-default-dark text-center">
          Smart Mining Monitoring
        </p>
      </router-link>
      <router-link
        class="navbar-brand group-logo justify-content-center align-items-center p-3 shadow-sm"
        :to="{ name: 'landing' }"
        v-else-if="user && user.id === '69cb6d6541335638abeff1d3'"
      >
        <img src="@/assets/logo/logo-2.png" class="h-50" alt="INFERENCE" />
        <p class="mb-0 text-default-dark text-center">
          Smart Mining Monitoring
        </p>
      </router-link>
      <router-link
        class="navbar-brand group-logo bg-semitrans-light justify-content-center align-items-center p-3 shadow-sm"
        :to="{ name: 'landing' }"
        v-else
      >
        <img
          src="@/assets/images/KSSBConsult.png"
          class=""
          alt="KSSB Consult"
        />
        <p class="mb-0 text-default-dark text-center">
          Smart Mining Monitoring
        </p>
      </router-link>
      <button
        class="navbar-toggler py-3 bg-default-dark"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <small>MENU</small>
      </button>
      <div
        class="collapse navbar-collapse bg-dark flex-grow-1"
        id="navbarSupportedContent"
      >
        <ul class="navbar-nav flex-lg-fill py-2 px-3">
          <li
            class="nav-item"
            v-for="link in navLinks"
            :key="`navLink-${link.name}`"
            :class="{ 'd-none': !link.show }"
          >
            <router-link :to="{ name: link.name }" class="nav-link">
              {{ link.label }}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="mr-3 ml-auto d-flex justify-content-end align-items-center">
        <div class="d-flex align-items-center mr-3">
          <button
            class="btn btn-outline-info btn-sm mr-2"
            @click="openLink('https://sims.semesta.com.my/')"
          >
            SIMS
          </button>

          <button
            class="btn btn-outline-info btn-sm mr-2"
            @click="openLink('https://hrserver.com.my/Account/Login')"
          >
            HR2000
          </button>

          <button
            class="btn btn-outline-info btn-sm"
            @click="
              openLink('https://kssbreflex.com/cmis/index.php/mainpage/login')
            "
          >
            CMIS
          </button>

          <button
            class="btn btn-outline-info btn-sm"
            @click="
              openLink(
                'https://kssbreflex.com/ams_uat/index.php/dashboard/landing'
              )
            "
          >
            HSE
          </button>
        </div>

        <site-dropdown class="d-none d-sm-flex mr-3" />
        <user-dropdown />
      </div>
    </nav>
    <slot></slot>
    <footer class="row mx-0 border-top border-dark bg-dark">
      <div class="col d-flex justify-content-start align-items-center">
        <p class="text-default-dark small mb-0 mr-2">Powered By</p>
        <img
          v-if="user && user.id === '69cb6d6541335638abeff1d3'"
          src="@/assets/logo/logo-2.png"
          style="height: 10px"
          alt="Powered by SELGEM"
        />
        <img
          v-else
          src="@/assets/images/powered-by-selgem.png"
          class="footer-logo"
          alt="Powered by SELGEM"
        />
      </div>
      <div class="col d-flex justify-content-end align-items-center">
        <p
          v-if="user && user.id === '69cb6d6541335638abeff1d3'"
          class="mb-0 small"
        >
          &copy; Inference {{ new Date().getFullYear() }}
        </p>
        <p v-else class="mb-0 small">
          &copy; SELGEM {{ new Date().getFullYear() }}
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import $ from "jquery";
import SiteDropdown from "@/components/SiteDropdown";
import UserDropdown from "@/components/UserDropdown";

export default {
  name: "layout-default",
  components: {
    SiteDropdown,
    UserDropdown,
  },
  data() {
    return {
      user: "",
    };
  },
  watch: {
    "$route.name": {
      handler() {
        const navbar = $("#navbarSupportedContent");

        navbar?.collapse("hide");
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    navLinks() {
      return [
        {
          name: "map",
          label: "Map",
          show: true,
        },
        {
          name: "dashboard",
          label: "Dashboard",
          show:
            this.user &&
            this.user.username !== "central-user" &&
            (this.user.username === "semesta-user" ||
              !this.user.sites ||
              this.user.sites.length == 0),
        },
        {
          name: "reports",
          label: "Reports",
          show: true,
        },
      ];
    },
  },
  mounted() {
    const user = localStorage.getItem("user");

    this.user = user ? JSON.parse(user) : "";
  },
  methods: {
    openLink(url) {
      window.open(url, "_blank");
    },
  },
};
</script>